import { createRouter, createWebHashHistory } from 'vue-router'
import IndexView from '../views/Index'
import NewsdetailView from '../views/newsdetail'
import NewslistView from '../views/newslist'
import ProjectlistView from '../views/projectlist'
import ProjectdetailView from '../views/projectdetail'

const routes = [
  {
    path: '/',
    name: 'index',
    meta:{title:"BOYUYINUO"},
    component: IndexView
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    meta:{title:"BOYUYINUO->NEWS DETAILS"},
    component: NewsdetailView
  },
  {
    path: '/newslist',
    name: 'newslist',
    meta:{title:"BOYUYINUO->NEWS LIST"},
    component: NewslistView
  },
  {
    path: '/projectlist',
    name: 'projectlist',
    meta:{title:"BOYUYINUO->PRODUCT LIST"},
    component: ProjectlistView
  },
  
  {
    path: '/projectdetail',
    name: 'projectdetail',
    meta:{title:"BOYUYINUO->PRODUCT DETAILS"},
    component: ProjectdetailView
  },
 
  
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 设置页面标题
  }
  next();
});
export default router
